import fetcher from '../../fetcher';

const login = (body) => fetcher(`/login`, 'POST', body);

export default login;
